// components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = ({ children }) => {
  const user_id = Cookies.get("user_id");
  return user_id ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
